<template>
  <span class="base-link" :class="[color, { 'is-small': isSmall }]">
    <a
      v-if="href !== ''"
      :href="href"
      :target="targetBlank ? '_blank' : '_self'"
      :rel="targetBlank ? 'noopener noreferrer' : null"
      class="base-link__element"
    >
      <slot>Text</slot>
    </a>
    <BaseIcon
      v-if="href !== '' && targetBlank"
      name="external-link"
      class="base-link__blank"
      @click="onExternalLinkClicked"
    />

    <router-link :to="to" class="base-link__element" v-else-if="to !== ''">
      <slot>Text</slot>
    </router-link>

    <button
      :disabled="disabled"
      :type="type"
      class="base-link__element"
      role="button"
      v-else-if="href === '' && to === ''"
    >
      <slot>Text</slot>
    </button>
  </span>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon';

export default {
  name: 'BaseLink',
  components: {
    BaseIcon,
  },
  props: {
    isSmall: Boolean,
    targetBlank: Boolean, // Available for href links only.
    disabled: Boolean, // Available for buttons only (no 'href' or 'to' specified).
    // Use button type for actions that do not go to another page. (presentation is the same)
    href: {
      // Always prioritised. Will use <a>
      type: String,
      default: '',
      required: false,
    },
    to: {
      // Internal link. Uses <router-link>
      type: [Object, String],
      default: '',
      required: false,
    },
    type: {
      // Optional. Allows to specify button type. "button|submit|reset"
      type: String,
      default: 'button',
      required: false,
    },
    color: {
      type: String,
      required: false,
    },
  },
  methods: {
    onExternalLinkClicked() {
      window.open(this.href, '_blank', 'noopener,noreferrer');
    },
  },
};
</script>

<style lang="scss">
.base-link {
  align-items: center;
  display: flex;

  &.normal {
    .base-link__element {
      color: $color-normal;
    }
  }

  &__element {
    align-items: center;
    align-self: center;
    background-color: transparent;
    border: none;
    color: $color-accent;
    cursor: pointer;
    display: inline-flex;
    font-size: inherit;
    outline: none;
    padding: 4px 0;
    position: relative;
    text-decoration: none;

    &::after {
      background: $color-accent-2;
      bottom: 2px;
      content: '';
      display: block;
      height: 1px;
      position: absolute;
      transition: bottom 100ms ease;
      width: 100%;
    }

    &:hover,
    &:active,
    &:focus {
      &::after {
        bottom: 0;
      }
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }

  &__blank {
    color: $color-neutral;
    margin-left: 4px;
    width: 16px;
    cursor: pointer;
  }

  &.is-small {
    font-size: 12px;

    .base-link__blank {
      width: 12px;
    }
  }
}
</style>
